<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      服务类订单
    </div>
    <div style="padding: 20px;">
      <div>
        <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList'>
          <template slot="daterange">
            <Daterange :startTime="searchForm.startTime" :endTime="searchForm.endTime" @dataChange='dataChange'></Daterange>
          </template>
        </Search>
        <div style="clear: both;"></div>
      </div>
      <div style="margin-top:10px">
        <template>

          <el-table
              :data="tableData"
              :height="th"
              v-loading="loading"
              border style="width: 100%;">
            <el-table-column prop="serialNumber" label="订单流水号" width="300"></el-table-column>
            <el-table-column prop="user.name" label="老人姓名" width="85"></el-table-column>
            <el-table-column prop="user.phone" label="手机号" width="150"></el-table-column>
            <el-table-column prop="orderGoods.goodsName" label="商品名称"
                             width="150"></el-table-column>
            <el-table-column prop="orderGoods.goodsPrice" label="单价(元)"
                             width="105"></el-table-column>
                             
            <el-table-column prop="orderGoods.number" width="105" label="购买数量"></el-table-column>
            <el-table-column prop="price" label="总价(元)" width="105"></el-table-column>
            <el-table-column prop="orderFrom" :formatter="getOrderFrom" width="105" label="订单来源" ></el-table-column>
            <el-table-column
                prop="status"
                :formatter="statuss"
                width="105"
                label="订单状态">
            </el-table-column>
            
            <!-- <el-table-column prop="listOrderGoodsDTO[0].planTime" :formatter="timefilter" width="200"
                             label="预约时间"></el-table-column> -->
            <el-table-column prop="createTime" :formatter="timefilter" width="200"
                             label="下单时间"></el-table-column>
            <el-table-column
                prop="orderType"
                :formatter="statusTitle"
                label="订单类型" width="150">
            </el-table-column>
            <el-table-column prop="serveName" label="服务人员" width="85"></el-table-column>
            <el-table-column prop="orderServe.startTime" :formatter="getSETime" width="200"
                             label="服务开始时间"></el-table-column>
            <el-table-column prop="orderServe.endTime" :formatter="getSETime" width="200"
                             label="服务结束时间"></el-table-column>
            
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="openQr(scope.row)">订单二维码</el-button>
                <!--                              <el-button type="primary" size="small" v-if="row.orderType===1"    >发货</el-button>-->
                <!-- <el-button type="primary" size="small" :loading="loading"  @click="deleteOrder(scope.row)" >删除</el-button> -->
              </template>
            </el-table-column>


          </el-table>

          <el-dialog
              title="二维码"
              :visible.sync="OpenQrCode"
              width="290px"
              top='30vh'
              class="QRCode">
            <div class="canvas-code" id="qrcode"></div>
          </el-dialog>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）
            </div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import {getStaffCode} from "@/utils/auth";
import QRCode from "qrcodejs2";
import Daterange from "@/components/Daterange";
import Search from "@/components/Search";
export default {
  name: "Role",
  data() {
    return {
      status1: -1,
      status1List: [
        {
          value: -1, label: '全部状态'
        }, {
          value: 10, label: '待付款'
        }, {
          value: 11, label: '待接单'
        }, {
          value: 12, label: '已接单'
        }, {
          value: 13, label: '服务中'
        }, {
          value: 14, label: '服务完成'
        }, {
          value: 15, label: '交易取消'
        }, {
          value: 16, label: '已评价'
        }
      ],
      OpenQrCode: false,
      loading: false,
      tableData: [],
      name: '',
      phone: '',
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,
      orderBusinessCode: '',
      startTime: '',
      endTime: '',
      searchForm:{
        name: '',
        phone: '',
        status:-1,
        startTime:'',
        endTime:''
      },
      searchData:''
    }
  },
  components: {
    Daterange,
    Search
  },
  created() {
    this.init();
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
    startTime(e) {
      console.log(e)
    }
  },
  methods: {
    init() {
      this.searchData=[
          {span:12,name:'老人姓名',value:'name',type:'input'},
          {span:12,name:'手机号',value:'phone',type:'input'},
          {span:12,name:'状态',value:'status',type:'select',options:this.status1List},
          {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
      ]
      this.searchForm.endTime = timefilters(new Date()).slice(0, 10)
      this.searchForm.startTime = timefilters(new Date(new Date() - 1000 * 60 * 60 * 24 * 30)).slice(0, 10)
    },
    dataChange(val) {
      this.searchForm.startTime = val[0]
      this.searchForm.endTime = val[1]
    },
    getOrderFrom(row){
      return  row.orderFrom=='xiaole'?'小乐下单':'app下单'
    },
    openQr(row) {
      this.OpenQrCode = true;
      if (document.getElementById("qrcode")) {
        document.getElementById("qrcode").innerHTML = "";
      }
      this.$nextTick(function () {
        this.qrcodeInit(row);
      })
    },
    statusTitle(row, column, cellValue) {
      return this.allStatus(cellValue, ["", '普通商品订单', '社会化服务订单', '政府购买服务订单']);
    },
    statuss(row, column, cellValue) {
      return this.allStatus(cellValue, ['待付款', '待发货', '待收货', '交易成功', '退款中', '交易关闭', '交易取消', '已评价', "", "", '待付款', '待接单', '已接单', '服务中', '服务完成', '交易取消', '已评价']);
    },
    allStatus(row, status) {
      for (var i in status) {
        if (i == row) {
          return status[i]
        }
      }
      return "其它";
    },
    //日期格式
    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },
    getSETime(row, column, cellValue) {
      if (cellValue) {
        var time = timefilters(cellValue);
        if (time == '1970-01-01 08:00:00') {
          return ''
        } else {
          return timefilters(cellValue)
        }
      }
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {
      if(isSearch)this.currentPage=1
      var _this=this
      this.loading=true
      let data={
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
      }
      Object.assign(data,this.searchForm)
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusiness/PageForServiceOrderAdm",
        data: data
      }).then((response) => {
        _this.loading = false;
        if (response.data.error === 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });
    },


    //  生成二维码
    qrcodeInit(row) {
      new QRCode('qrcode', {
        width: 250,
        height: 250,        // 高度
        text: row.orderBusinessCode,   // 二维码内容
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      })
    },

  }
}
</script>

<style scoped>


/* .QRCode {
  text-align: center;
  width: 1000px;
  margin-left: 400px;
  margin-top: 150px;
} */

</style>
